
import React from 'react';
import { Button } from "@/components/ui/button";
import { Loader2 } from 'lucide-react';

interface LoadMoreButtonProps {
  isLoading: boolean;
  onLoadMore: () => Promise<void>;
}

const LoadMoreButton: React.FC<LoadMoreButtonProps> = ({ isLoading, onLoadMore }) => {
  return (
    <div className="flex justify-center mt-6">
      <Button 
        onClick={onLoadMore} 
        disabled={isLoading}
        variant="outline"
        size="lg"
      >
        {isLoading ? (
          <>
            <Loader2 className="mr-2 h-4 w-4 animate-spin" />
            Loading more results...
          </>
        ) : (
          'Load More Results'
        )}
      </Button>
    </div>
  );
};

export default LoadMoreButton;
